/* eslint-disable no-console */
import { setupTrackers } from './setupTrackers';
import { getModelNameFromUrl } from './getModelNameFromUrl';
import { updateTrackers } from './updateTrackers';
import { getRankings } from './getRankings';
import { processEngine } from './processEngine';
import { saveDataToLocalStorage } from './saveDataToLocalStorage';
import { isBuildPage } from './isBuildPage';
import { isModelLandingPage } from './isModelLandingPage';
import { createLocalStorageObjectToSave } from './createLocalStorageObjectToSave';
import { MAX_COUNT_ALL_URLS } from './constants';

export function handleUrlChange(_currentUrl) {
  // Return in node
  if (typeof window === 'undefined') {
    return null;
  }
  const currentUrl = _currentUrl || window.location.href;
  const isNewConfiguratorPageRegex = isBuildPage(currentUrl);
  const isNewMlpPageRegex = isModelLandingPage(currentUrl);

  if (!isNewConfiguratorPageRegex && !isNewMlpPageRegex) {
    console.log('End Script ...');
    return;
  }

  let storedData = null;
  if (typeof window !== 'undefined') {
    storedData = window.localStorage.getItem('audiModelTracker');
  }

  const parsedData = storedData ? JSON.parse(storedData) : null;
  const localStorageTracker = setupTrackers();

  if (storedData) {
    const existingUrls = parsedData.allUrls || [];

    const allUserUrls = [...existingUrls];
    // if less than max, add new url to front of array
    if (existingUrls.length < MAX_COUNT_ALL_URLS) {
      allUserUrls.unshift(currentUrl);
    }
    localStorageTracker.allUrls = allUserUrls;

    if (isNewMlpPageRegex) {
      // eslint-disable-next-line no-unneeded-ternary
      const hasMlp = parsedData.hasMlpInput || isNewMlpPageRegex ? true : false;
      localStorageTracker.hasMlpInput = hasMlp;
    }

    if (isNewConfiguratorPageRegex) {
      const hasBuild =
        // eslint-disable-next-line no-unneeded-ternary
        parsedData.hasConfiguratorInput || isNewConfiguratorPageRegex ? true : false;
      localStorageTracker.hasConfiguratorInput = hasBuild;
    }
  } else {
    // first time user loads app
    const allUserUrls = [currentUrl];
    localStorageTracker.allUrls = allUserUrls;
    localStorageTracker.hasMlpInput =
      // eslint-disable-next-line no-unneeded-ternary
      isNewMlpPageRegex && !isNewConfiguratorPageRegex ? true : false;
    // eslint-disable-next-line no-unneeded-ternary
    localStorageTracker.hasConfiguratorInput = isNewConfiguratorPageRegex ? true : false;
  }

  if (isNewConfiguratorPageRegex) {
    localStorageTracker.lastSavedBuildUrl = currentUrl;
  } else if (isNewMlpPageRegex) {
    localStorageTracker.lastSavedBuildUrl = storedData
      ? JSON.parse(storedData)?.lastSavedBuildUrl
      : null;
  }

  const currentUrlModelName = getModelNameFromUrl(currentUrl);

  try {
    updateTrackers(currentUrlModelName, localStorageTracker);

    const { rankedPriceRanges, rankedBodyTypes } = getRankings(localStorageTracker);

    const { finalReccomendations, buildCTAType } = processEngine(
      currentUrlModelName, // <-- NOT USED
      rankedBodyTypes,
      rankedPriceRanges,
      localStorageTracker,
    );

    const completedReccomendations = createLocalStorageObjectToSave(
      finalReccomendations,
      buildCTAType,
      localStorageTracker.lastSavedBuildUrl,
    );

    saveDataToLocalStorage(localStorageTracker, completedReccomendations);
    return completedReccomendations;
  } catch (e) {
    console.log('error: ', e);
  }
}
